import React from "react";
import { Skeleton, Space } from "antd";
import { PageContainer, PageHeader, TimelineContainer, ClaimSummaryCard, InvoicesSection, TableContainer } from "./Claims.styled";

export const ClaimsLoading: React.FC = () => {
  return (
    <PageContainer>
      <PageHeader>
        <Skeleton.Input active style={{ width: 200, height: 32 }} />
        <Skeleton.Button active style={{ width: 120 }} />
      </PageHeader>

      <div style={{ marginBottom: 16 }}>
        <Space size={16} wrap>
          <Skeleton.Input active style={{ width: 200 }} />
          <Skeleton.Input active style={{ width: 200 }} />
          <Skeleton.Input active style={{ width: 150 }} />
        </Space>
      </div>

      <Skeleton active paragraph={{ rows: 10 }} />
    </PageContainer>
  );
};

export const ClaimsAnalyticsLoading: React.FC = () => {
  return (
    <PageContainer>
      {/* Back button */}
      <Skeleton.Button active style={{ width: 140, marginBottom: 16 }} />

      {/* Header */}
      <PageHeader>
        <Skeleton.Input active style={{ width: 200, height: 32 }} />
      </PageHeader>

      {/* Filters */}
      <div style={{ marginBottom: 24, padding: 16, background: "#fff", borderRadius: 8 }}>
        <Space size={16} wrap>
          <Skeleton.Input active style={{ width: 250 }} />
        </Space>
      </div>

      {/* Stats Cards */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 16, marginBottom: 24 }}>
        {[1, 2, 3, 4].map((i) => (
          <div key={i} style={{ padding: 24, background: "#fff", borderRadius: 8 }}>
            <Skeleton.Input active size="small" style={{ width: 100, marginBottom: 8 }} />
            <Skeleton.Input active style={{ width: 120, height: 32 }} />
          </div>
        ))}
      </div>

      {/* Charts */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 16, marginBottom: 24 }}>
        <div style={{ padding: 24, background: "#fff", borderRadius: 8 }}>
          <Skeleton.Input active style={{ width: 150, marginBottom: 16 }} />
          <Skeleton active paragraph={{ rows: 8 }} />
        </div>
        <div style={{ padding: 24, background: "#fff", borderRadius: 8 }}>
          <Skeleton.Input active style={{ width: 200, marginBottom: 16 }} />
          <Skeleton active paragraph={{ rows: 8 }} />
        </div>
      </div>

      {/* Breakdowns */}
      <div style={{ padding: 24, background: "#fff", borderRadius: 8 }}>
        <Skeleton.Input active style={{ width: 150, marginBottom: 16 }} />
        <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 16 }}>
          {[1, 2, 3, 4].map((i) => (
            <div key={i} style={{ padding: 16, border: "1px solid #f0f0f0", borderRadius: 8 }}>
              <Skeleton active paragraph={{ rows: 4 }} />
            </div>
          ))}
        </div>
      </div>
    </PageContainer>
  );
};

export const ClaimDetailLoading: React.FC = () => {
  return (
    <PageContainer>
      {/* Back button */}
      <Skeleton.Button active style={{ width: 120, marginBottom: 16 }} />

      {/* Header */}
      <PageHeader>
        <Skeleton.Input active style={{ width: 250, height: 32 }} />
        <Space>
          <Skeleton.Button active style={{ width: 100 }} />
          <Skeleton.Button active style={{ width: 100 }} />
          <Skeleton.Button active style={{ width: 120 }} />
        </Space>
      </PageHeader>

      {/* Timeline */}
      <TimelineContainer>
        <Space size={48}>
          {[1, 2, 3, 4].map((i) => (
            <div key={i} style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 8 }}>
              <Skeleton.Avatar active size={32} />
              <Skeleton.Input active style={{ width: 60, height: 14 }} />
            </div>
          ))}
        </Space>
      </TimelineContainer>

      {/* Summary Card */}
      <ClaimSummaryCard>
        <div className="summary-header">
          <Skeleton.Input active style={{ width: 150, height: 24 }} />
          <Skeleton.Button active style={{ width: 80 }} />
        </div>
        <div className="summary-grid">
          {[1, 2, 3, 4, 5, 6].map((i) => (
            <div key={i} className="summary-item">
              <Skeleton.Input active size="small" style={{ width: 100, marginBottom: 4 }} />
              <Skeleton.Input active style={{ width: 120 }} />
            </div>
          ))}
        </div>
      </ClaimSummaryCard>

      {/* Invoices Section */}
      <InvoicesSection>
        <div className="section-header">
          <Skeleton.Input active style={{ width: 150, height: 24 }} />
          <Skeleton.Input active style={{ width: 250 }} />
        </div>
        <TableContainer>
          <Skeleton active paragraph={{ rows: 8 }} />
        </TableContainer>
      </InvoicesSection>
    </PageContainer>
  );
};
